import { createFileRoute } from '@tanstack/react-router'

import { RandomNumberDisplayPage } from '@/components/pages/Admin/RandomNumber/RandomNumberDisplayPage'

export const Route = createFileRoute('/_liff/random-number-display')({
  component: RandomNumberDisplayPage,
  staticData: {
    authRequired: false, // Maybe the projector doesn't need login?
    // Actually, usually it's better if it does, but for convenience sometimes it's public.
    // The user said "for internal use" for log and settings, but display is for "main projector".
    // I'll keep authRequired: false for ease of use on a projector laptop.
  },
})
